import { NgModule } from "@angular/core";
import { EntityDataService, EntityServices } from "@ngrx/data";
import { MedicalDeviceRepository } from "./impl/service/repository/medicalDevice.repository";
import { MedicalDeviceDataService } from "./impl/service/repository/medicalDevice.dataservice";

@NgModule({
})
export class MedicalDeviceAccountModule {
    constructor(
        entityDataService: EntityDataService,
        entityServices: EntityServices,
        repository: MedicalDeviceRepository,
        dataService: MedicalDeviceDataService
    ) {
        entityDataService.registerServices({
            MedicalDevice: dataService,
        });
        entityServices.registerEntityCollectionServices({
            MedicalDevice: repository,
        });
    }
}

